import { Box, Grid, MenuItem, Stack, Typography } from '@mui/material'
import { OrderItemChip } from '@planning/pages/Order/components/OrderItemChip'
import { IOrderItem } from '@planning/rt-stores/order/OrderItem'
import { useTranslate } from '@tolgee/react'
import { DangerousIcon, HighlightedText, ThreeDotMenu, useMinimalsTheme } from '@tom-ui/ui'
import { ContainerNumber, formatPosition } from '@tom-ui/utils'
import { observer } from 'mobx-react-lite'

interface RestowListItemProps {
  data: IOrderItem
  highlightText?: string
  onDelete: (id: number) => void
}

export const RestowListItem = observer(({ data, highlightText, onDelete }: RestowListItemProps) => {
  const theme = useMinimalsTheme()
  const { t } = useTranslate()

  return (
    <Grid
      key={`grp-row-${data.data.containerNumber}`}
      container
      paddingLeft={'1rem'}
      paddingRight={'1rem'}
      height={'60px'}
      display={'flex'}
      alignItems={'center'}
      borderBottom={`1px solid ${theme.palette.grey[300]}`}
      data-cy='order-group-list-item'
    >
      <Grid textAlign={'start'} size={2}>
        <Stack direction={'row'} spacing={1} alignItems={'center'}>
          <Box>
            <ContainerNumber value={data.data.containerNumber} format={false} variant='body2'>
              <HighlightedText highlight={highlightText} color={theme.palette.info.main}>
                {data.data.containerNumber}
              </HighlightedText>
            </ContainerNumber>
            {/* <Typography component={'div'} variant='mini'>
              <HighlightedText highlight={'filter'} color={'blue'}>
                {data.referenceNumber}
              </HighlightedText>
            </Typography> */}
          </Box>
        </Stack>
      </Grid>
      <Grid
        alignSelf={'center'}
        textAlign={'start'}
        size={{
          xs: 7,
          xl: 7,
        }}
      >
        <Stack direction={'row'} spacing={0.5}>
          <OrderItemChip label={data.data.containerIsoCode}></OrderItemChip>
          <OrderItemChip label={(data.data.isEmpty && 'E') || 'F'} />
          {!!data.data.grossWeight && (
            <OrderItemChip
              label={`${t('gwt', 'GWT')}: ${data.data.grossWeight.toLocaleString(undefined, { maximumFractionDigits: 0 })}kg`}
            />
          )}
          {data.data.imoClasses && data.data.imoClasses.length > 0 && (
            <OrderItemChip
              label={
                <Typography
                  display={'flex'}
                  gap={'4px'}
                  fontSize={'14px'}
                  sx={{ alignItems: 'center' }}
                  component={'div'}
                  variant='body2'
                >
                  <DangerousIcon sx={{ height: '16px', width: '16px', marginRight: '4px' }} />
                  {data.data.imoClasses.join(', ')}
                </Typography>
              }
            />
          )}
          {data.data.stowagePosition && (
            <OrderItemChip
              label={`${t('originSlot', 'Origin slot')}: ${formatPosition(data.data.stowagePosition)} `}
            />
          )}
          {/* {data.data.destination && (
            <OrderItemChip
              label={`${t('targetSlot', 'Target slot')}: ${formatPosition(data.destination)}`}
            />
          )} */}
        </Stack>
      </Grid>
      <Grid textAlign={'end'} onClick={event => event.stopPropagation()} size={3}>
        <Grid container>
          {/* <Grid item xs={10} xl={11} sx={{ placeContent: 'center' }}>
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                placeContent: 'flex-end',
                gap: '4px',
              }}
            >
              <OrderStatusChip status={'Open'} />
            </Box>
          </Grid> */}
          <Grid size={12}>
            <ThreeDotMenu>
              <MenuItem onClick={() => onDelete(data.id)}>{t('delete')}</MenuItem>
            </ThreeDotMenu>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  )
})
